export let posts = [];

export let postIdCounter = Date.now();
export let commentIdCounter = Date.now();

export function setPosts(nextPosts) {
  posts = nextPosts;
}

export function appendPosts(nextPosts) {
  const seen = new Set(posts.map(p => p.id));
  for (const post of nextPosts) {
    if (!seen.has(post.id)) {
      posts.push(post);
      seen.add(post.id);
    }
  }
}

export function addPost(post) {
  posts.unshift(post);
  postIdCounter++;
}

export function addCommentToPost(postId, comment) {
  const post = posts.find(p => p.id === postId);
  if (post) {
    post.comments.push(comment);
    commentIdCounter++;
  }
}
